<template>
  <el-dialog
      :title="title"
      :visible.sync="visible"
      width="700px"
      @close="handlerCancel"
      class="custom-el-wrapper"
  >

    <el-form ref="form" :model="form" label-width="100px"	v-loading="loading">

			<el-input inline v-model="form.order_num" placeholder="请输入" style="width:280px;text-align: center;">
				<template #prepend>
					<el-select v-model="form.limit_day"  style="width:150px;">
						<el-option label="7天订单量小于" value="7" />
						<el-option label="15天订单量小于" value="15" />
						<el-option label="30天订单量小于" value="30" />
					</el-select>
				</template>
				<template #append>单</template>
			</el-input>
			<el-input v-model="form.delete_day" placeholder="请输入" style="width:200px;text-align: center;">
				<template #append>天后自动删除</template>
			</el-input>

    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button @click="handlerCancel">取 消</el-button>
      <el-button type="primary" @click="handlerConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapActions } from "vuex";
export default {
  data() {
    return {
      visible: false,
      form:{
      	limit_day: '7',
				order_num: '',
				delete_day: ''
      },
      title:'',
			loading: false
    }
  },
  mounted() {

  },
  methods: {
		...mapActions({
			getStrategyDeleteSet:"ucenter_order/getStrategyDeleteSet",//获取策略删除设置
			opEditStrategyDeleteSet:"ucenter_order/opEditStrategyDeleteSet",//编辑策略删除设置
		}),
    open(title){
      this.title = title;
			this.initSetInfo();
      this.visible = true;
    },
		initSetInfo(){
			this.loading = true
			this.getStrategyDeleteSet({
				data: {},
				success: (res) => {
					this.loading = false
					if (res.code === 200) {
						const d = res.data || {}
						this.form = {
							limit_day: d.limit_day != null && d.limit_day !== '' ? String(d.limit_day) : '7',
							order_num: d.order_num != null && d.order_num !== '' ? String(d.order_num) : '',
							delete_day: d.delete_day != null && d.delete_day !== '' ? String(d.delete_day) : ''
						}
					} else {
						this.$message({ message: res.msg || '获取设置失败', type: 'error' })
					}
				}
			})
		},
    handlerConfirm(){
			if (this.form.limit_day == null || this.form.limit_day === '') {
				this.$message({ message: '请选择统计周期', type: 'warning' })
				return
			}
			const orderNum = Number(this.form.order_num)
			if (this.form.order_num === '' || Number.isNaN(orderNum) || orderNum < 0 || !Number.isInteger(orderNum)) {
				this.$message({ message: '请输入有效的订单量阈值（非负整数）', type: 'warning' })
				return
			}
			const deleteDay = Number(this.form.delete_day)
			if (this.form.delete_day === '' || Number.isNaN(deleteDay) || deleteDay < 1 || !Number.isInteger(deleteDay)) {
				this.$message({ message: '请输入有效的自动删除天数（正整数）', type: 'warning' })
				return
			}
			this.loading = true
			this.opEditStrategyDeleteSet({
				data: {
					limit_day: Number(this.form.limit_day),
					order_num: orderNum,
					delete_day: deleteDay
				},
				success: (res) => {
					this.loading = false
					if (res.code === 200) {
						this.$message({ message: res.msg || '保存成功', type: 'success' })
						this.$emit('refresh')
						this.visible = false
					} else {
						this.$message({ message: res.msg || '保存失败', type: 'error' })
					}
				}
			})
    },
    handlerCancel(){
      this.visible = false;
			this.loading = false
    },
  }
}
</script>

<style scoped>
.el-form{
	display: flex;
	gap: 10px;
	align-items: center;
	justify-content: center;
}
.el-input-group--append .el-input__inner{
	text-align: center;
}
</style>
